import React from "react";
import Dropdown from "../../Utility/Dropdown/Dropdown";
import Button from "../../Utility/Button/Button";
import { RiAddLine } from "react-icons/ri";
import AddButton from "../../Utility/AddButton/AddButton";

const BillingFilter = ({
  filters,
  onFilterChange,
  tagOptions = [],
  accountOptions = [],
  clientOptions = [],
  qbClientOptions = [],
  onAddMapping,
  notShowClient = true,
  notShowQBClient = true,

  notShowTag = true,
  notShowAccount = true,

  addMappingButton = true,

  // User Rate Mapping
  notShowUser = true,
  notShowAction = true,
  userOptions = [],
}) => {
  return (
    <div className="flex justify-between items-center gap-3 mb-4 min-h-[50px]">
      {/* LEFT SIDE */}
      <div className="flex items-center gap-2 flex-wrap">
        {/* Select Tag */}
        {notShowTag && (
          <div className="min-w-[150px]">
            <Dropdown
              name="tag"
              value={filters?.tag || "Select Tag"}
              onChange={onFilterChange}
              options={tagOptions.length ? tagOptions : ["Select Tag"]}
              placeholder="Select Tag"
              noWrapper
            />
          </div>
        )}

        {/* Enter / Select Account */}
        {notShowAccount && (
          <div className="min-w-[260px]">
            <Dropdown
              name="account"
              value={filters?.account || "Enter Account"}
              onChange={onFilterChange}
              options={accountOptions.length ? accountOptions : ["Enter Account"]}
              placeholder="Enter Account"
              noWrapper
            />
          </div>
        )}

        {/* Client */}
        {notShowClient && (
          <div className="min-w-[180px]">
            <Dropdown
              name="client"
              value={filters?.client || "All Clients"}
              onChange={onFilterChange}
              options={clientOptions.length ? clientOptions : ["All Clients"]}
              placeholder="All Clients"
              noWrapper
              searchable
            />
          </div>
        )}

        {/* QuickBooks Client */}
        {notShowQBClient && (
          <div className="min-w-[260px]">
            <Dropdown
              name="qbClient"
              value={filters?.qbClient || "Search QuickBooks Client"}
              onChange={onFilterChange}
              options={qbClientOptions.length ? qbClientOptions : ["Search QuickBooks Client"]}
              placeholder="Search QuickBooks Client"
              searchable
              noWrapper
            />
          </div>
        )}

        {/* USER / ROLE DROPDOWN */}
        {notShowUser && (
          <div className="min-w-[220px]">
            <Dropdown
              name="user"
              value={filters?.user || "Select User"}
              onChange={onFilterChange}
              options={userOptions}
              placeholder="Select User"
              searchable
              noWrapper
            />
          </div>
        )}
        {/* ACTION DROPDOWN */}
        {notShowAction && (
          <div className="min-w-[220px]">
            <Dropdown
              name="action"
              value={filters?.action || "Select Action"}
              onChange={onFilterChange}
              options={["Select Action", "Increase Rate", "Decrease Rate", "Override Rate"]}
              placeholder="Select Action"
              noWrapper
            />
          </div>
        )}
      </div>

      {/* RIGHT SIDE */}

      {addMappingButton && (
        <>
          <AddButton onClick={onAddMapping} tooltip="Add Mapping" tooltipPosition="right" />
        </>
      )}
    </div>
  );
};

export default BillingFilter;
